import React from 'react';

import { useAccountsMapping } from 'src/services/accountsMapping';

import OtherConnectedAccounts from 'src/views/Admin/components/OtherConnectedAccounts';

import JiraCredentialsForm from './JiraCredentialsForm';
import PagerDutyCredentialsForm from './PagerDutyCredentialsForm';
import RemoveAccountsConnectionButton from './RemoveAccountsConnectionButton';
import Summary from './Summary';

const AccountsMappingSummary = () => {
  const [accountsMapping] = useAccountsMapping();
  if (!accountsMapping) return null;

  return (
    <div data-cy="top-level-accounts-mapping-summary" style={{ width: '90%' }}>
      <div style={{ display: 'flex', flexFlow: 'row nowrap', marginBottom: 40, marginTop: 20, alignItems: 'stretch' }}>
        <div style={{ width: '45%' }}>
          <PagerDutyCredentialsForm accountsMapping={accountsMapping}/>
          <div style={{ height: 40 }}/>
          <JiraCredentialsForm accountsMapping={accountsMapping}/>
        </div>
        <div style={{ flexGrow: 1 }}/>
        <div style={{ width: '45%', display: 'flex', flexFlow: 'column nowrap', justifyContent: 'space-between' }}>
          <Summary accountsMapping={accountsMapping}/>
          <RemoveAccountsConnectionButton accountsMapping={accountsMapping}/>
        </div>
      </div>
      <OtherConnectedAccounts/>
    </div>
  );
};

export default AccountsMappingSummary;
